import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'max'})
export class MaxPipe implements PipeTransform {
  transform(value: string, ...args: any[]): any {
    if (!value) return value;

    let allowed = args[0];
    let received = value.length;

    if (received > allowed && allowed !== 0) {
      let toCut = allowed - received;
      return value.slice(0, toCut);
    }

    return value;
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./~/angular2-notifications/src/max.pipe.ts